import { Box, FormControlLabel, Grid, Radio } from "@mui/material";
import * as React from "react";
import { Dropdown, IDropdownAction } from "ui/Scripts/source/components/framework/Dropdown/Dropdown";
import { EnumHelper, UserGroupType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { IUnitPermissionUserGroup } from "../../../../../models/userGroup/unitPermissionUserGroup";
import { ActionContainer } from "../../../ActionContainer";
import { GridRow } from "../../../Grid/GridRow";
import { ListIconButtonsPermission } from "../../../List/ListIconButtons/ListIconButtonsPermission";

interface IUnitApplicationPermissionsHeaderProp {
    disabled: boolean;
    cardView: boolean;
    hideAllUsers: boolean;
    hideUserGroups: boolean;
    userGroupType: UserGroupType;
    userGroupDropDownItems: IDropdownAction[]
    userGroup: IUnitPermissionUserGroup;
    allUsersGroup: boolean;
    permissionsCopied: boolean;
    selectedUnitId: string;
    onChangeUserGroupTypeAll: () => void;
    onChangeUserGroupType: (userGroupType: UserGroupType) => void;
    onUserGroupChange: (userGroupCode: string) => void;
    onEditPermission: (id: string) => void;
    onCopyPermissions: () => void;
    onPastePermissions: () => void;
}

export const UnitApplicationPermissionsHeader = (props: IUnitApplicationPermissionsHeaderProp) => {
    const handleChangeUserGroupTypeAll = (checked: boolean) => {
        if (!checked) return;
        props.onChangeUserGroupTypeAll();
    };

    const handleChangeUserGroupType = (checked: boolean, userGroupType: UserGroupType) => {
        if (!checked) return;
        props.onChangeUserGroupType(userGroupType);
    };

    return (
        <Box sx={{ margin: props.cardView ? "-1rem 1rem 2rem" : "-1rem 0 2rem" }}>
            <GridRow sx={{ marginTop: "0" }}>
                {!props.hideAllUsers &&
                    <Grid item sm={4}>
                        <FormControlLabel
                            label={Translations.UserGroupAll}
                            control={
                                <Radio
                                    checked={props.allUsersGroup}
                                    onChange={(_e, checked: boolean) => handleChangeUserGroupTypeAll(checked)}
                                />
                            }
                        />
                    </Grid>
                }
                {!props.hideUserGroups &&
                    <Grid item sm={4}>
                        <FormControlLabel
                            label={Translations.UserGroups}
                            control={
                                <Radio
                                    checked={!props.allUsersGroup && EnumHelper.isEqual(props.userGroupType, UserGroupType.Normal)}
                                    onChange={(_e, checked: boolean) => handleChangeUserGroupType(checked, UserGroupType.Normal)}
                                />
                            }
                        />
                    </Grid>
                }
                {(!props.hideAllUsers || !props.hideUserGroups) &&
                    <Grid item sm={4}>
                        <FormControlLabel
                            label={Translations.Users}
                            control={
                                <Radio
                                    checked={!props.allUsersGroup && EnumHelper.isEqual(props.userGroupType, UserGroupType.Fixed)}
                                    onChange={(_e, checked: boolean) => handleChangeUserGroupType(checked, UserGroupType.Fixed)}
                                />
                            }
                        />
                    </Grid>
                }
            </GridRow>
            <ActionContainer
                leftItems={
                    <Dropdown
                        selectedTitle={props.userGroup.name}
                        selectMode={true}
                        actions={props.userGroupDropDownItems}
                    />
                }
                rightItems={
                    <ListIconButtonsPermission
                        editTooltip={Translations.EditPermission}
                        copyTooltip={Translations.CopyGroupPermissions}
                        pasteTooltip={Translations.PasteGroupPermissions}
                        editDisabled={props.disabled}
                        copyDisabled={props.disabled}
                        pasteDisabled={props.disabled || !props.permissionsCopied}
                        onEdit={() => props.onEditPermission(props.selectedUnitId)}
                        onCopy={props.onCopyPermissions}
                        onPaste={props.onPastePermissions}
                    />
                }
            />
        </Box>
    );
};